// src/components/ToolContainer.js
import React, { useState } from 'react';
import './ToolContainer.css';

const ToolContainer = ({ tool }) => {
  const [activeTab, setActiveTab] = useState('Dashboard');

  const tabs = ['Dashboard', 'Reports', 'Configuration', 'Settings'];

  const renderContent = () => {
    switch (activeTab) {
      case 'Dashboard':
        return <div>This is the Dashboard content for {tool.title}.</div>;
      case 'Reports':
        return <div>This is the Reports content for {tool.title}.</div>;
      case 'Configuration':
        return <div>This is the Configuration content for {tool.title}.</div>;
      case 'Settings':
        return <div>This is the Settings content for {tool.title}.</div>;
      default:
        return null;
    }
  };

  return (
    <div className="tool-container">
      <div className="tool-header">
        <h1>{tool.title}</h1>
        <p>{tool.description}</p>
      </div>
      <div className="tool-tabs">
        {tabs.map(tab => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="tool-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default ToolContainer;
